import { call, put, select } from 'redux-saga/effects';

import { authTokenSelector } from 'store/auth/selectors';
import { openSupportForm, openSupportFormSuccess } from 'store/user/actions';
import { selectCurrentUser } from 'store/user/selectors';
import { UserStore } from 'store/user/types';

import { decagonClient } from 'services/decagonClient';
import sentry from 'services/Sentry/SentryInstance';

import { generateContactUsLink } from 'hooks/common/helpers';

import { redirectTo } from 'helpers/utils';

import { waitForGetAuthTokenRequest } from './helpers';

function* redirectToContactUsFallback() {
    const { first_name, email, id, payment_platform, gender, country }: UserStore = yield select(selectCurrentUser);
    const authToken: string | null = yield select(authTokenSelector);

    const href = generateContactUsLink({
        first_name,
        id,
        email,
        payment_platform,
        gender,
        country,
        authToken,
    });

    yield call(redirectTo, href);
}

export function* openSupportFormSaga({ payload }: ReturnType<typeof openSupportForm>) {
    const { chatIsVisible = false } = payload ?? {};

    try {
        yield call(waitForGetAuthTokenRequest);
    } catch (error) {
        sentry.sentrySagaLog(error as Error, 'openSupportFormSaga');

        yield* redirectToContactUsFallback();

        return;
    }

    const authToken: string | null = yield select(authTokenSelector);

    if (chatIsVisible && authToken) {
        try {
            yield call(decagonClient.initialise, { authToken });

            yield call(decagonClient.open);

            yield put(openSupportFormSuccess());
        } catch (e) {
            yield* redirectToContactUsFallback();
        }
    } else {
        yield* redirectToContactUsFallback();
    }
}

export function* closeChatbotSaga() {
    try {
        yield call(decagonClient.hide);
    } catch (error) {
        sentry.sentrySagaLog(error as Error, 'closeChatbotSaga');
    }
}
